import {
    ADD_BRAND_TO_TEAM,
    ADD_BRAND_TO_TEAM_FAIL,
    ADD_BRAND_TO_TEAM_SUCCESS,
    ADD_JURISDICTION_TO_TEAM,
    ADD_JURISDICTION_TO_TEAM_FAIL,
    ADD_JURISDICTION_TO_TEAM_SUCCESS,
    DELETE_BRAND_FROM_TEAM,
    DELETE_BRAND_FROM_TEAM_FAIL,
    DELETE_BRAND_FROM_TEAM_SUCCESS,
    DELETE_JURISDICTION_FROM_TEAM,
    DELETE_JURISDICTION_FROM_TEAM_FAIL,
    DELETE_JURISDICTION_FROM_TEAM_SUCCESS
} from './actionTypes';

// Jurisdictions
export const addJurisdictionToTeam = ({ teamId, jurisdictions }) => ({
    type: ADD_JURISDICTION_TO_TEAM,
    payload: { teamId, jurisdictions }
});

export const addJurisdictionToTeamSuccess = team => ({
    type: ADD_JURISDICTION_TO_TEAM_SUCCESS,
    payload: team
});

export const addJurisdictionToTeamFail = error => ({
    type: ADD_JURISDICTION_TO_TEAM_FAIL,
    payload: error
});

export const deleteJurisdictionFromTeam = ({ teamId, jurisdictionCode }) => ({
    type: DELETE_JURISDICTION_FROM_TEAM,
    payload: { teamId, jurisdictionCode }
});

export const deleteJurisdictionFromTeamSuccess = team => ({
    type: DELETE_JURISDICTION_FROM_TEAM_SUCCESS,
    payload: team
});

export const deleteJurisdictionFromTeamFail = error => ({
    type: DELETE_JURISDICTION_FROM_TEAM_FAIL,
    payload: error
});

// Brands
export const addBrandToTeam = ({ teamId, jurisdictionCode, brandId }) => ({
    type: ADD_BRAND_TO_TEAM,
    payload: { teamId, jurisdictionCode, brandId }
});

export const addBrandToTeamSuccess = team => ({
    type: ADD_BRAND_TO_TEAM_SUCCESS,
    payload: team
});

export const addBrandToTeamFail = error => ({
    type: ADD_BRAND_TO_TEAM_FAIL,
    payload: error
});

export const deleteBrandFromTeam = ({ teamId, jurisdictionCode, brandId }) => ({
    type: DELETE_BRAND_FROM_TEAM,
    payload: { teamId, jurisdictionCode, brandId }
});

export const deleteBrandFromTeamSuccess = team => ({
    type: DELETE_BRAND_FROM_TEAM_SUCCESS,
    payload: team
});

export const deleteBrandFromTeamFail = error => ({
    type: DELETE_BRAND_FROM_TEAM_FAIL,
    payload: error
});
